import React from 'react'
import styled from '@emotion/styled'
import Select from 'react-select'

import { ALERTLEVEL } from 'Constants'

const SelectAlert = styled(Select)`
  width: 100%;
`

export const allOptionAlert = { value: null, label: 'All' }
export const alertOptions = Object.keys(ALERTLEVEL).map(level => {
  return {
    value: ALERTLEVEL[level],
    label: level.charAt(0) + level.toLowerCase().slice(1)
  }
})

export default React.memo(({ includeAll, ...props }) => {
  const options = [...alertOptions]
  if (includeAll) {
    options.unshift(allOptionAlert)
  }

  return <SelectAlert options={options} {...props} />
})
